'use strict';
var util = __webpack_require__(/*! ./util */ "./janieandjack-sfra/cartridges/app_janieandjack_storefront/cartridge/client/default/js/util.js");


module.exports = {
    emailbind: function () {
        // Get references to the email and confirmation input fields
        var $email = $("#registration-form-email");
        var $confirmEmail = $("#registration-form-email-confirm");

        var emailValue = $email.val();
        $confirmEmail.val(emailValue);

        // Bind the change event to the email input field
        $email.on("change", function() {
            // Get the value of the email input field
            emailValue = $email.val();
            // Set the value of the confirmation input field to match the email input
            $confirmEmail.val(emailValue);
        });
    },
    passwordValidation: function() {
        $('.js-password-restriction').on('keyup keydown change', function () {
            var value = $(this).val();
            validatePassword(value);
        });
        if ($('.js-password-restriction').length > 0) {
            validatePassword($('.js-password-restriction').val());
        }
        $('#newPassword, #newPasswordConfirm').on('blur', function(e) {
            const passwordInput = $(this).val();
            const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*?()_+.]).{8,20}$/;
            var validationMessage = $(this).data('pattern-mismatch');
            const $input = $(this);
            const $formGroup = $input.closest('div.form-group');
            const $invalidFeedback = $formGroup.find('.invalid-feedback');
            var isValid = false;
            if (passwordInput.length > 0) {
                if (passwordRegex.test(passwordInput)) {
                    $input.removeClass('is-invalid').addClass('has-success');
                    $invalidFeedback.text('');
                    $('.password-form-caption').removeClass('hidden');
                    $(".change-password-form button").css('pointer-events', '');
                    isValid = true;
                } else {
                    $input.addClass('is-invalid').removeClass('has-success');
                    $invalidFeedback.text(validationMessage);
                    $('.password-form-caption').addClass('hidden');
                    $(".change-password-form button").css('pointer-events', 'none');
                }
            }
            if(isValid && $("#newPasswordConfirm").val().length > 0 && $("#newPassword").val().length > 0) {
                if($("#newPasswordConfirm").val() !== $("#newPassword").val()) {
                    validationMessage = $("#newPasswordConfirm").data('passwords-donotmatch');
                    $("#newPasswordConfirm").addClass('is-invalid').removeClass('has-success');
                    $("#newPasswordConfirm").closest('div.form-group').find('.invalid-feedback').text(validationMessage);
                    $(".change-password-form button").css('pointer-events', 'none');
                } else {
                    $("#newPasswordConfirm").addClass('has-success').removeClass('is-invalid');
                    $("#newPasswordConfirm").closest('div.form-group').find('.invalid-feedback').text('');
                    $(".change-password-form button").css('pointer-events', '');
                }
            }
        });
    },
    checkGiftCertificateBalance: function () {
        var $giftCertCode = $('#giftCertificateID');
        var $giftCertPin = $('#giftCertificatePin');
        $('#check-giftcert').on('click', function (e) {
            e.preventDefault();
            var $balance = $('.giftcard-balance-result');
            var error;
            if ($giftCertCode.length === 0 || $giftCertCode.val().length === 0) {
                error = $balance.find('span.error');
                if (error.length === 0) {
                    error = $('<span>').addClass('error').appendTo($balance);
                }
                error.html(Resources.GIFT_CERT_MISSING);
                return;
            }

            if ($giftCertPin.length === 0 || $giftCertPin.val().length === 0) {
                error = $balance.find('span.error');
                if (error.length === 0) {
                    error = $('<span>').addClass('error').appendTo($balance);
                }
                error.html(Resources.GIFT_CERT_PINMISSING);
                return;
            }

            var url = $('.gift-certificate-form').attr('action');

            $.ajax({
                type: 'POST',
                url: url,
                data: { gift_giftCertCode: $giftCertCode.val(), gift_giftCertPin: $giftCertPin.val() },
                success: function success(data) {
                    if (!data.success) {
                        error = $balance.find('span.error');
                        if (error.length === 0) {
                            error = $('<span>').addClass('error').appendTo($balance);
                        }
                        error.html(Resources.GIFT_CERT_INVALID).removeClass('success').addClass('error');
                        return;
                    } else {
                        $balance.html('').removeClass('error').addClass('success')
                            .append('<div class="giftCertCode col-6">' + data.ID + '</div>')
                            .append('<div class="giftCertPin col-3">' + data.pin + '</div>')
                            .append('<div class="giftCertBalance p-0 price col-3">'+ data.balance + '</div>');
                    }
                }
            });
        });
    }
};

function validatePassword(value) {
    if (/[A-Za-z\d$@.()$!%*\-?&#^_+\.]{8,20}/.test($.trim(value))) {
        $('.js-password-rule-characters').addClass('verified');
    } else {
        $('.js-password-rule-characters').removeClass('verified');
    }
    if (/[a-z]/.test($.trim(value))) {
        $('.js-password-rule-lowercase').addClass('verified');
    } else {
        $('.js-password-rule-lowercase').removeClass('verified');
    }
    if (/[A-Z]/.test($.trim(value))) {
        $('.js-password-rule-uppercase').addClass('verified');
    } else {
        $('.js-password-rule-uppercase').removeClass('verified');
    }
    if (/[0-9]/.test($.trim(value))) {
        $('.js-password-rule-numbers').addClass('verified');
    } else {
        $('.js-password-rule-numbers').removeClass('verified');
    }
    if (/[$@.()$!%*#^?&+_\-]/.test($.trim(value))) {
        $('.js-password-rule-specialchars').addClass('verified');
    } else {
        $('.js-password-rule-specialchars').removeClass('verified');
    }
}

function validatePasswordValue(value) {
    const minLength = 8;
    const maxLength = 20;

    const hasMinimumLength = value.length >= minLength;
    const hasMaximumLength = value.length <= maxLength;
    const hasLowerCase = /[a-z]/.test(value);
    const hasUpperCase = /[A-Z]/.test(value);
    const hasDigit = /\d/.test(value);
    const hasSpecialCharacter = /[$@.()$!%*#^?&+_\-]/.test(value);

    return (
        hasMinimumLength &&
        hasMaximumLength &&
        hasLowerCase &&
        hasUpperCase &&
        hasDigit &&
        hasSpecialCharacter
    );
}
function validatePasswordField($input) {
    var value = $input.val();

    if (value.length > 0) {
        var isValid = validatePasswordValue(value);

        const $formGroup = $input.closest('div.form-group');
        const $invalidFeedback = $formGroup.find('.invalid-feedback');

        if (!isValid) {
            $invalidFeedback.text($input.data('pattern-mismatch'));
        } else {
            $invalidFeedback.text('');
        }
    }
}
$(document).ready(function() {
    // Extract text content from breadcrumb and set it as h3 text
    var breadcrumbText = $('.breadcrumb-item:not(:has(a))').text().trim();
    if (!breadcrumbText) {
        breadcrumbText = $('.breadcrumb-item:last').text().trim();
    }
    $('.section-title h3').text(breadcrumbText);
    $('#registration-form-password, #registration-form-password-confirm').on('blur', function() {
        validatePasswordField($(this));
    });
    $('#requestPasswordResetModal').on('hidden.bs.modal', function () {
        location.reload();
    });
    if($('.dashboard .whoimshoppingfor-info .block-body .body').length > 0) {
        $('.dashboard .whoimshoppingfor-info .block-body .body').not('slick-initialized').slick({
            arrows: true,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<button class="slider-prev button-text" type="button"     aria-label="Previous">' + util.svg('Arrow_small', 'left-arrow') + '</a>',
            nextArrow: '<button class="slider-next button-text" type="button"     aria-label="Next">' + util.svg('Arrow_small', 'right-arrow') + '</a>'
        });
    }
    function addClassesToButtons(selector) {
        var buttons = $(selector);
        if (buttons.length > 0) {
            buttons.addClass("btn").addClass("btn-primary");
        }
    }
    addClassesToButtons(".janieandjack-login-asset .button-wrapper .button");
    addClassesToButtons(".track-order-help .content-asset .button");
    
    if ($('.dashboard .wishlist-dashboard-body').length > 0) {
        $('.dashboard .wishlist-dashboard-body').not('slick-initialized').slick({
            arrows: true,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<a class="slider-prev">' + util.svg('Arrow_small', 'left-arrow') + '</a>',
            nextArrow: '<a class="slider-next">' + util.svg('Arrow_small', 'right-arrow') + '</a>'

        });
    }
    if($(".forgot-password-mobile").length > 0) {
        $(document).on("click", ".forgot-password-mobile a", function(e) {
            $("#password-reset").trigger("click");
        });
    }
});

exports.init = function () {
    $('.js-password-restriction').on('keyup keydown change', function () {
        var value = $(this).val();
        validatePassword(value);
    });
    if ($('.js-password-restriction').length > 0) {
        validatePassword($('.js-password-restriction').val());
    }
};